class ImagePreview {
    preview(file, callback) {
        if (window.FileReader) {
            const readerInstance = new FileReader();

            const allowedTypes = ['image/gif', 'image/jpeg', 'image/png'];
            if (!allowedTypes.includes(file.type)) {
                return;
            }

            readerInstance.onload = (e) => {
                callback(e.target.result);

                return;
            };

            readerInstance.onerror = () => {
                return;
            };

            readerInstance.readAsDataURL(file);
        }
    }
}

export default ImagePreview;
